const initialState = {
  totalAttendance: {},
};

export const dashboardReducer = (state = initialState, action) => {
  switch (action.type) {
    case "get_total_attendance":
      return {
        ...state,
        totalAttendance: action.payload,
      };
    default:
      return state;
  }
};

// reducers/dashboardReducer.js

const dashboardRed = {
  designationAttendance: [],
};

export const dashboardDesReducer = (state = dashboardRed, action) => {
  switch (action.type) {
    case "get_designation_attendance":
      return {
        ...state,
        designationAttendance: action.payload,
      };
    default:
      return state;
  }
};
